import { render, staticRenderFns } from "./BacEllipsisLoader.vue?vue&type=template&id=4ee897de&scoped=true&"
import script from "./BacEllipsisLoader.vue?vue&type=script&lang=ts&"
export * from "./BacEllipsisLoader.vue?vue&type=script&lang=ts&"
import style0 from "./BacEllipsisLoader.vue?vue&type=style&index=0&id=4ee897de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee897de",
  null
  
)

export default component.exports